import script from "./EnunciadoHome.vue?vue&type=script&setup=true&lang=js"
export * from "./EnunciadoHome.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__